import { html, css, svg, LitElement, render } from 'lit';
export class ShowCaseComponent extends LitElement {

    static properties = {

        // myString: { type: String },
        link: {
            type: String,
            attribute: true,
        },
        badge: {
            type: String,
            attribute: true,
        },
        title: {
            type: String,
            attribute: true,
        },
        // myBool: { type: Boolean },
    }
    static get styles() {
        // Write styles in standard CSS
        // https://stackoverflow.com/questions/25193964/how-can-i-have-a-web-components-width-and-height-be-inherited-by-its-children
        return css`
			:host {
			display: inline-block;  /* or display: block; */
			}
		`;
    }
    constructor() {
        super();
        this.link = 'Link';
        this.badge = 'badge!';
        // this.shadowRoot.mode('open');
    }

    // TODO: overriding update causes shit
    // update() {
    // 	console.log('[AsynchronousOverviewSmallItemComponent] update');
    // 	let c = new ContentSiteLineClampModule();
    // 	c.setRoot(this.shadowRoot);
    // 	c.initialize();
    // }

    // TODO: Important! Use 'updated' instead of 'update' because 'update' is used to update, and 'updated' is used to handle updated DOM
    updated() {

    }
    // <slot></slot>
    render() {
        let result = html`
        <slot @slotchange=${this.handleSlotChange}></slot>
        <slot name="badge"></slot>
        <slot name="category"></slot>
        <slot name="intro"></slot>
        `;
        return result;
    }

    handleSlotChange(event) {
        // console.log('handleSlotChange', event);
        // // ... do something with childNodes ...
        // this.allText = childNodes.map((node) => {
        //   return node.textContent ? node.textContent : ''
        // }).join('');
        // console.log('allText', this.allText);
    }

}
window.customElements.define('showcase-component', ShowCaseComponent);